// import Vue from 'vue'
import * as types from './mutation-types'
import Vue from 'vue';
// import moment from 'moment'
// import { isValueEmptyProto } from '../../../utils/utils';

const mutation = {
  [types.GET_ALL_ADMIN](state, data) {
    state.quote_list_admin = data
  },
  [types.SET_ADMIN_SUGGESTED_OFFER](state, data){
    data.originalofferResponseTypeID = data.offerResponseTypeID;
    state.selectedAdminQuote.vehicles[0].offers.splice(0,0,data);
  },
  [types.SET_SELECTED_QUOTE_ADMIN](state, data) {
    // Used Vue.set to make state object reactive throughout
    if(data && Object.keys(data).length > 0 && data.constructor === Object){
      let AdminQuote = {
        quoteID: data.quoteID,
        customerID: data.customerID,
        modifiedByUserID: data.modifiedByUserID,
        createdByUserID: data.createdByUserID,
        dateCreated: data.dateCreated,
        dateModified: data.dateModified,
        marketID: data.marketID,
        ownerByUserID: data.ownerByUserID,
        quoteStatusTypeID: data.quoteStatusTypeID,
        quoteOriginTypeID: data.quoteOriginTypeID,
        stateProofOfIdentificationID: data.stateProofOfIdentificationID == 0 ? null : data.stateProofOfIdentificationID
      }
      Vue.set(state, 'selectedAdminQuote', AdminQuote)

      if(data.market){
        Vue.set(state.selectedAdminQuote, 'market', data.market)
        // state.selectedAdminQuote.market = data.market;
      }
      if(data.customer){
        Vue.set(state.selectedAdminQuote, 'customer', data.customer)
        // state.selectedAdminQuote.customer = data.customer;
      }
      if(data.quotePickupLocation){
        Vue.set(state.selectedAdminQuote, 'quotePickupLocation', data.quotePickupLocation)
        // state.selectedAdminQuote.quotePickupLocation = data.quotePickupLocation;
      }
      if(data.followups != null && data.followups[0] != null){
        Vue.set(state.selectedAdminQuote, 'followups', data.followups)
        // state.selectedAdminQuote.followups = data.followups;
      }
      if(data.vehicles != null && data.vehicles[0] != null){
        // let vehicle = [{
        //   vehicleID: data.vehicles[0].vehicleID,
        //   quoteID: data.vehicles[0].quoteID,
        //   makeID: data.vehicles[0].makeID,
        //   modelID: data.vehicles[0].modelID,
        //   modelYear: data.vehicles[0].modelYear,
        //   vin: data.vehicles[0].vin,
        //   proofOfOwnershipID: data.vehicles[0].proofOfOwnershipID,
        //   operable: data.vehicles[0].operable,
        //   tagNumber: data.vehicles[0].tagNumber,
        //   isActive: data.vehicles[0].isActive,
        //   dateCreated: data.vehicles[0].dateCreated,
        //   dateModified: data.vehicles[0].dateModified,
        //   make: data.vehicles[0].make,
        //   model: data.vehicles[0].model,
        //   components: data.vehicles[0].components,
        //   has_damage: null,
        //   conditionDescription: data.vehicles[0].conditionDescription,
        //   titleNumber: data.vehicles[0].titleNumber,
        //   vehiclePriceAdjustment: data.vehicles[0].vehiclePriceAdjustment,
        // }]
        // state.selectedAdminQuote.vehicles = data.vehicles;
        Vue.set(state.selectedAdminQuote, 'vehicles', data.vehicles)

        if(data.vehicles[0].offers != null && data.vehicles[0] != null){
          let formattedOffers = data.vehicles[0].offers;
          formattedOffers.forEach(element => { return element.originalofferResponseTypeID = element.offerResponseTypeID; });
          Vue.set(state.selectedAdminQuote.vehicles[0], 'offers', formattedOffers)
        }
        // state.selectedAdminQuote.vehicles[0].offers = formattedOffers;
        // if(data.vehicles[0].offers != null && data.vehicles[0].offers[0] != null){
        //   var offers = [{
        //     offerID: data.vehicles[0].offers[0].offerID,
        //     vehicleID: data.vehicles[0].offers[0].vehicleID,
        //     suggestedPrice: data.vehicles[0].offers[0].suggestedPrice,
        //     maxAllowedPrice: data.vehicles[0].offers[0].maxAllowedPrice,
        //     offerPrice: data.vehicles[0].offers[0].offerPrice,
        //     offerResponseTypeID: data.vehicles[0].offers[0].offerResponseTypeID,
        //     offeredByEmployeeID: data.vehicles[0].offers[0].offeredByEmployeeID,
        //     zipcode: data.vehicles[0].offers[0].zipcode,
        //     isActive: data.vehicles[0].offers[0].isActive,
        //     dateCreated: data.vehicles[0].offers[0].dateCreated,
        //     dateModified: data.vehicles[0].offers[0].dateModified,
        //   }]
        //   state.selectedAdminQuote.vehicles[0]['offers'] = offers;
        // }

        // if(data.vehicles[0].currentOffer != null){
        //   let currentOffer = {
        //     offerID: data.vehicles[0].currentOffer.offerID,
        //     vehicleID: data.vehicles[0].currentOffer.vehicleID,
        //     suggestedPrice: data.vehicles[0].currentOffer.suggestedPrice,
        //     maxAllowedPrice: data.vehicles[0].currentOffer.maxAllowedPrice,
        //     offerPrice: data.vehicles[0].currentOffer.offerPrice,
        //     offerResponseTypeID: data.vehicles[0].currentOffer.offerResponseTypeID,
        //     offeredByEmployeeID: data.vehicles[0].currentOffer.offeredByEmployeeID,
        //     zipcode: data.vehicles[0].currentOffer.zipcode,
        //     isActive: data.vehicles[0].currentOffer.isActive,
        //     dateCreated: data.vehicles[0].currentOffer.dateCreated,
        //     dateModified: data.vehicles[0].currentOffer.dateModified,
        //   }
        //   state.selectedAdminQuote.vehicles[0]['currentOffer'] = currentOffer;
        // }
      } 

      if(data.callInformations != null && data.callInformations[0] != null){
        Vue.set(state.selectedAdminQuote, 'callInformations', data.callInformations)
        // state.selectedAdminQuote.callInformations = data.callInformations
      }
      if(data.stateProofOfIdentification != null){
        Vue.set(state.selectedAdminQuote, 'stateProofOfIdentification', data.stateProofOfIdentification)
        // state.selectedAdminQuote.stateProofOfIdentification = data.stateProofOfIdentification
      }
      if(data.wizardStepStack != null){
        Vue.set(state.selectedAdminQuote, 'wizardStepStack', data.wizardStepStack)
        // state.selectedAdminQuote.wizardStepStack = data.wizardStepStack
      }
      if(data.quoteThirdPartyPartner != null)
      {
        Vue.set(state.selectedAdminQuote, 'quoteThirdPartyPartner', data.quoteThirdPartyPartner)
        // state.selectedAdminQuote.quoteThirdPartyPartner = data.quoteThirdPartyPartner;
      }
      if(data.remoteQuoteMap != null)
      {
        Vue.set(state.selectedAdminQuote, 'remoteQuoteMap', data.remoteQuoteMap)
        // state.selectedAdminQuote.remoteQuoteMap = data.remoteQuoteMap;
      }
    }
  },
  [types.LOAD_MODELS_BY_MAKE_AND_YEAR](state, models) {
    state.car_model_list = models
  },
  [types.UPDATE_QUOTE](state, quote) {
    let selectedQuote = state.quote_list.map((item) => {
      if (item.quoteID === quote.quoteID) {
        item = quote
        return item
      }
    })
  },
  [types.SET_PAQ_ACCESS_TOKEN](state, token) {
    state.paqAccessToken = token;
  }
  // [types.SET_QUOTE_STATUS](state, quotestatus) {
  //   state.new_quote.status = quotestatus;
  // }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/quotes/mutations.js